import { Tag, theme } from "antd";
import React, { CSSProperties } from "react";

import { JobTagProps } from "./types";

export const JobTag: React.FC<JobTagProps> = ({ icon, color, bordered = true, children, borderColor, textColor }) => {
  const { token } = theme.useToken();

  const customStyle: CSSProperties = {
    display: "inline-flex",
    padding: "2px 8px",
    justifyContent: "center",
    alignItems: "center",
    textTransform: "uppercase",
    lineHeight: "22px",
    fontSize: 12,
    fontWeight: 700,
  };

  if (borderColor) {
    customStyle.borderColor = borderColor;
  }

  if (textColor) {
    customStyle.color = textColor;
  }

  return (
    <Tag icon={icon} color={color || token.colorPrimary} bordered={bordered} style={customStyle}>
      {children}
    </Tag>
  );
};
